import { Navigate, Outlet } from 'react-router-dom';
import type { Role } from '@mcper/core';
import { useAuthStore } from '../../store/auth.store';
import { hasRole } from './roles';

/** Route group for pages whose API is role-gated: anyone below `minimum` is sent to `fallback` instead of a page that cannot load. */
export function RequireRole({ minimum, fallback }: { minimum: Role; fallback: string }) {
  const role = useAuthStore((s) => s.principal?.role);
  if (!hasRole(role, minimum)) return <Navigate to={fallback} replace />;
  return <Outlet />;
}
